<template>
  <div>
    <v-data-table :headers="headers" :items="paymentMethodItems" class="elevation-1">
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-toolbar-title>Wallet</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-dialog v-model="dialog" max-width="500px" persistent>
            <template v-if="permission.includes('Create Metode Pembayaran')" v-slot:activator="{ on }">
              <v-btn color="primary" small dark class="mb-2" v-on="on" @click="[dialog = true]">Buat Wallet</v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="headline">{{formTitle}}</span>
              </v-card-title>
              <v-card-text>
                <v-row>
                  <v-col cols="12" sm="6" md="12">
                    <v-text-field v-model="editedItem.name" label="Nama Wallet" required></v-text-field>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="close()">Cancel</v-btn>
                <v-btn color="blue darken-1" text @click="save()">Save</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
        <v-row class="ml-2 mt-4">
            <v-col cols="3">   
                <v-btn block depressed small color="primary" height="35px" @click="[filterModalVisible = true]">
                  <v-icon>mdi-filter</v-icon>
                  Filter
                </v-btn>
                <v-dialog
                  v-model="filterModalVisible"
                  max-width="500px"
                  persistent
                >
                  <v-card>
                    <v-card-title>
                      Filter Wallet
                    </v-card-title>
                    <v-card-text>
                      <v-text-field type="datetime-local" v-model="fromDateFilter" label="Dari Tanggal"></v-text-field>
                      <v-text-field type="datetime-local" v-model="toDateFilter" label="Sampai Tanggal"></v-text-field>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" text @click="[filterModalVisible = false]">Cancel</v-btn>
                      <v-btn color="blue darken-1" text @click="handleFilterByDate">Update</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
            </v-col>
          </v-row>
          <v-row v-if="showFilteredTitle" class="ml-2">
          <v-col class="d-flex"><h5>Filter Wallet <span style="color: #1976d2;" class="font-weight-bold">{{formatdate(fromDateFilter)}}</span> sampai <span style="color: #1976d2;" class="font-weight-bold">{{formatdate(toDateFilter)}}</span></h5>
          <v-btn
            @click="resetFilter"
            style="margin-left: 10px;"
            outlined
            small
            fab
            color="indigo"
          >
            <v-icon>mdi-backup-restore</v-icon>
          </v-btn>
          </v-col>
        </v-row>
      </template>
      <template v-slot:[`item.no`]="{ item }">
        {{(paymentMethodItems.indexOf(item)+1) + '.'}}
      </template>
      <template v-slot:[`item.margin`]="{ item }">
        <v-chip small class="ma-2 white--text" label :color="item.margin < 0 ? 'red' : 'green' "> {{ convertCurrency(item.margin) }}</v-chip>
      </template>
      <template v-slot:[`item.saldo`]="{ item }">
        <v-chip small class="ma-2 white--text" label :color="item.saldo < 0 ? 'red' : 'green' "> {{ convertCurrency(item.saldo) }}</v-chip>
      </template>
      <template v-slot:no-data>
        <span class="text-center">No data available.</span>
      </template>
      <template v-slot:[`item.action`]="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-icon v-on="on" small class="mr-2" v-if="permission.includes('Update Metode Pembayaran')" @click="editItem(item)">edit</v-icon>
          </template>
          <span>Edit</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-icon v-on="on" small class="mr-2" v-if="permission.includes('Delete Metode Pembayaran')" @click="deleteItem(item)">delete</v-icon>
          </template>
          <span>Hapus</span>
        </v-tooltip>
      </template>
    </v-data-table>
    <v-data-table :headers="headerRekonsiliasi" :items="rekonsiliasiItems" class="elevation-1" style="margin-top:20px;">
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-toolbar-title>Rekonsiliasi</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-dialog v-model="dialogRekonsiliasi" max-width="500px" persistent>
            <template v-if="permission.includes('Create Metode Pembayaran')" v-slot:activator="{ on }">
              <v-btn color="primary" small dark class="mb-2" v-on="on" @click="[dialogRekonsiliasi = true]">Buat Rekonsiliasi</v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="headline">{{formTitleRekonsiliasi}}</span>
              </v-card-title>
              <v-card-text>
                <v-row>
                  <v-col cols="12" sm="6"  md="12">
                    <v-select 
                      hide-details 
                      v-model="editedItemRekonsiliasi.payment_method_id_from" 
                      :items="paymentMethodItems" 
                      item-value="id"
                      item-text="name" 
                      label="From"/>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="6" md="12">
                    <v-select 
                      hide-details
                      v-model="editedItemRekonsiliasi.payment_method_id_to" 
                      :items="paymentMethodItems" 
                      item-value="id"
                      item-text="name" 
                      label="To"/>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="6" md="12">
                    <v-text-field v-model="editedItemRekonsiliasi.jumlah" label="Jumlah" required></v-text-field>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closeDialogRekonsiliasi()">Cancel</v-btn>
                <v-btn color="blue darken-1" text @click="saveRekonsiliasi()">Save</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:[`item.no`]="{ item }">
        {{(rekonsiliasiItems.indexOf(item)+1) + '.'}}
      </template>
      <template v-slot:no-data>
        <span class="text-center">No data available.</span>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import forEach from "lodash/forEach";
import slice from "lodash/slice";
import find from "lodash/find";
import isEmpty from "lodash/isEmpty";
import itemTemplate from '@/components/ItemTemplate.vue';
import { formatCurrency } from "@/libs/number";
import dayjs from "dayjs";
import moment from "moment";


export default {
  data: () => ({
    itemTemplate,
    dialog: false,
    dialogRekonsiliasi: false,
    expand: false,
    role: '',
    permission: [],
    showError: false,
    headerRekonsiliasi: [
      {
        text: "No.",
        align: "left",
        value: "no"
      },
      { text: "From", value: "name_from" },
      { text: "To", value: "name_to" },
      { text: "Jumlah", value: "jumlah" },
    ],
    headers: [
      {
        text: "No.",
        align: "left",
        value: "no"
      },
      { text: "Wallet", value: "name" },
      { text: "Total Pemasukan", value: "total_pemasukan" },
      { text: "Total Pengeluaran", value: "total_pengeluaran" },
      { text: "Margin", value: "margin" },
      { text: "Saldo", value: "saldo" },
      { text: "Actions", align: "center", value: "action", sortable: false }
    ],
    paymentMethodItems: [],
    rekonsiliasiItems: [],
    item: '',
    editedIndex: -1,
    editedItem: {},
    editedItemRekonsiliasi: {},
    defaultItem: {},
    defaultItemRekonsiliasi: {},
    filterModalVisible: false,
    toDateFilter: null,
    fromDateFilter: null,
    showFilteredTitle: false,
  }),

  computed: {
    ...mapGetters({
    }),
    
    formTitle() {
      return this.editedIndex === -1 ? "Buat Wallet" : "Edit Wallet";
    },
    formTitleRekonsiliasi(){
      return "Buat Rekonsiliasi";
    }
  },

  watch: {
    dialog(val) {
      val || this.close();
    }
  },

  created() {
    this.initialize();
  },

  methods: {
    ...mapActions({
      getPaymentMethods: "payment_methods/getPaymentMethods",
      createPaymentMethods: "payment_methods/createPaymentMethods",
      updatePaymentMethods: "payment_methods/updatePaymentMethods",
      deletePaymentMethods: "payment_methods/deletePaymentMethods",
      getRekonsiliasi: "rekonsiliasi/getRekonsiliasi",
      createRekonsiliasi: "rekonsiliasi/createRekonsiliasi",
      filterPaymentMethod: "payment_methods/filterPaymentMethod",
    }),
    async handleFilterByDate(){
      if(!dayjs(this.fromDateFilter).isValid() || !dayjs(this.toDateFilter).isValid()) {
        return this.$notify({
            group: 'custom-notification',
            type: 'error',
            title: 'Error!',
            text: 'Format tanggal salah!'
        });
      }
      if(this.fromDateFilter > this.toDateFilter) {
        return this.$notify({
            group: 'custom-notification',
            type: 'error',
            title: 'Error!',
            text: 'Dari tanggal tidak boleh lebih besar!'
        });
      }
      this.paymentMethodItems = []
      let payload = {
        date_from: dayjs(this.fromDateFilter).format("YYYY-MM-DDTHH:mm"),
        date_to: dayjs(this.toDateFilter).format("YYYY-MM-DDTHH:mm"),
      }

      let response = await this.filterPaymentMethod(payload)
      
      await forEach(response.data.attributes, data => {
        data.total_pemasukan = this.convertCurrency(data.total_pemasukan)
        data.total_pengeluaran = this.convertCurrency(data.total_pengeluaran)
        this.paymentMethodItems.push(data)
      })
      this.showFilteredTitle = true;
      this.filterModalVisible = false
    },
    async resetFilter(){
      this.showFilteredTitle = false;
      this.filterModalVisible = false
      this.toDateFilter= null
      this.fromDateFilter= null
      this.dataPaymentMethods()
    },
    async dataPaymentMethods(){
      this.paymentMethodItems = []
      const dataItem = await this.getPaymentMethods()
      await forEach(dataItem.data.attributes, data => {
        data.total_pemasukan = this.convertCurrency(data.total_pemasukan)
        data.total_pengeluaran = this.convertCurrency(data.total_pengeluaran)
        this.paymentMethodItems.push(data)
      })
    },
    async dataRekonsiliasi(){
      this.rekonsiliasiItems = []
      const responseRekosiliansi = await this.getRekonsiliasi()

      await forEach(responseRekosiliansi.data.attributes, data => {
        data.jumlah = this.convertCurrency(data.jumlah)
        this.rekonsiliasiItems.push(data)
      })
    },
    formatdate(value){
      return moment(value).format("DD-MM-YYYY HH:mm")
    },
    async initialize() {
      const userLogin = JSON.parse(window.localStorage.getItem('user_data'))
      this.role = userLogin.roles[0].name
      this.permission = userLogin.permissions
      this.dataPaymentMethods()
      this.dataRekonsiliasi()
    }, 

    editItem(data) {
      this.editedIndex = this.paymentMethodItems.indexOf(data)
      this.editedItem = Object.assign({}, data)
      this.dialog = true
    },
    editItemRekonsiliasi(data){
      this.editIndexRekonsiliasi = this.rekonsiliasiItems.indexOf(data)
      
      this.editedItemRekonsiliasi = Object.assign({}, data)
      let j =  this.editedItemRekonsiliasi.jumlah.split('Rp.')
      let h = j[1].split(',')
      this.editedItemRekonsiliasi.jumlah = h[0]
      this.dialogRekonsiliasi = true
    },
    convertCurrency(total){
      return "Rp. "+formatCurrency(total);
    },
    async deleteItem(item) {
      const index = this.paymentMethodItems.indexOf(item);
      if(confirm("Apakah anda yakin menghapus wallet ini?")){
         await this.deletePaymentMethods(item.id);
         this.paymentMethodItems.splice(index, 1);
         this.$notify({
          group: 'custom-notification',
          type: 'success',
          title: 'Success!',
          text: `Sukses menghapus wallet ${item.name}`
        });
      }
    },
    closeDialogRekonsiliasi(){
      this.dialogRekonsiliasi = false;
      setTimeout(() => {
        this.editedItemRekonsiliasi = Object.assign({}, this.defaultItemRekonsiliasi);
        this.editIndexRekonsiliasi = -1;
      }, 300);
    },
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    async save() {
      try{
        if (this.editedIndex > -1) {
          const data = {
            'id': this.editedItem.id,
            'name' : this.editedItem.name
          }
          const response = await this.updatePaymentMethods(data)
          if(response.status == 200){
            this.dataPaymentMethods()
          }
        } else {
          const response = await this.createPaymentMethods(this.editedItem)
          if(response.status == 200){
            this.dataPaymentMethods()
          }
        }
        this.close();
      }catch(e){
        console.log(e)
      }
    },
    async saveRekonsiliasi() {
      try{
          const response = await this.createRekonsiliasi(this.editedItemRekonsiliasi)
          if(response.status == 200){
            this.$notify({
              group: 'custom-notification',
              type: 'success',
              title: 'Success!',
              text: 'Berhasil Melakukan Rekonsiliasi'
            });
            this.dataPaymentMethods()
            this.dataRekonsiliasi()
          }
        this.closeDialogRekonsiliasi();
      }catch(e){
        console.log(e)
      }
    }
  }
};
</script>
<style>
.vue-suggestion .vs__input {
    width: 100%;
    text-align: left;
    border-bottom: 1px solid black;
    max-height: 400px;
    overflow-y: auto;
    font-size: 16px;
    color: black;
    position: relative;
}
.vue-suggestion .vs__list {
    width: 100%;
    text-align: left;
    border: none;
    border-top: none;
    max-height: 400px;
    overflow-y: auto;
    border-bottom: 1px solid #023d7b;
    position: relative;
}
.vue-suggestion .vs__list .vs__list-item {
    position: relative;
    z-index: 1;
    background-color: #fff;
    padding: 10px;
    border-left: 1px solid #023d7b;
    border-right: 1px solid #023d7b;
}
.vue-suggestion .vs__list .vs__list-item:last-child {
    border-bottom: none;
}
.vue-suggestion .vs__list .vs__list-item:hover {
    background-color: #eee !important;
}
.vue-suggestion .vs__list,
.vue-suggestion .vs__loading {
    position: absolute;
}
.vue-suggestion .vs__list .vs__list-item {
    cursor: pointer;
}
.vue-suggestion .vs__list .vs__list-item.vs__item-active {
    background-color: #f3f6fa;
}
</style>